{
  "fr": {
    "posts": {
      "index": {
        "title": "Nouveautés de fobizz",
        "empty": "Il n'y a actuellement aucune nouveauté pour cette langue.",
        "error": "Les nouveautés n'ont pas pu être chargées. Veuillez réessayer plus tard.",
        "pinnedAria": "Publication épinglée",
        "publishedAt": "Publié le {date}"
      }
    }
  }
}
